<script>
  import { FontAwesomeIcon } from '@fortawesome/svelte-fontawesome';
  import { faGhost } from '@fortawesome/pro-light-svg-icons';
  import { navigate as goto } from 'svelte-routing';
  import { onMount } from 'svelte';
  import { page } from '$stores/pageStore';
  import { useErrorPage } from '$lib/hooks/useErrorPage';

  // Use our custom hook to prevent navigation away from this page
  useErrorPage('404');

  // Folded from former [...catchall]/+page.js: surface the catchall path.
  $: path = $page.url.pathname.replace(/^\/+/, '');

  onMount(() => {
    console.log('404 page loaded:', $page.url.href);
    // Disable any automatic navigation
    history.pushState = history.replaceState;
  });

  // Handle the home navigation with explicit control
  function goHome() {
    // We'll do a full page reload which is more reliable in this case
    window.location.href = '/';
  }
</script>

<div class="flex flex-col items-center justify-center min-h-[50vh] p-4">
  <div class="text-center">
    <div class="text-6xl mb-4 dark:text-white">
      <FontAwesomeIcon icon={faGhost} />
    </div>

    <h1 class="text-3xl font-bold mb-10 dark:text-white">This is not the page you are looking for.</h1>

    <p class="mb-8 text-gray-600 dark:text-gray-400">404 - Page Not Found</p>

    <button
      on:click={goHome}
      class="inline-flex items-center px-6 py-3 text-sm text-white dark:text-gray-200 bg-stone-600 dark:bg-gray-600 rounded-lg hover:bg-stone-700 dark:hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-stone-500 dark:focus:ring-gray-500 transition-colors duration-200"
    >
      Home
    </button>
  </div>
</div>
